import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "content"]

  connect() {
    this.close({ preventDefault() {} })
  }

  // Only the panel's width animates. The content area is permanently
  // `lg:flex-1` with a `max-w-6xl` reading column, so it reflows smoothly as
  // the panel grows/shrinks — no instant jump from toggling non-animatable
  // properties (`max-width: none`, `margin: auto`). This makes "open" the exact
  // reverse of "close": the panel grows in from the right / shrinks out to it.
  open(event) {
    event.preventDefault()
    this.panelTarget.classList.remove("pointer-events-none", "translate-x-full", "opacity-0", "lg:w-0")
    this.panelTarget.classList.add("translate-x-0", "opacity-100", "lg:w-[34rem]")
  }

  close(event) {
    event.preventDefault()
    this.panelTarget.classList.add("pointer-events-none", "translate-x-full", "opacity-0", "lg:w-0")
    this.panelTarget.classList.remove("translate-x-0", "opacity-100", "lg:w-[34rem]")
  }
}
